// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"502a83d5","342":"bb62299f","463":"c1e5a4b1","787":"d0aae870","988":"858cfa1c"}[chunkId] + ".chunk.js";
};